/* Post-print one-tap rating (desktop printPreview/PrintRatingToast, IIG Phase 5 §4.10): after a catalog or AI
 * poster prints, ask "How did it turn out?" — stars feed poster_feedback through the Printables fork, the heart
 * saves it as a favourite. Never required; closes itself after 15 s. */
import { useEffect, useState } from 'react';
import PosterRatingBar from '../../components/common/PosterRatingBar.jsx';
import usePrintables from '../../services/usePrintables.js';
import { Icon } from '../../ui/index.jsx';
import { usePrintStore } from './PrintStore.jsx';
import { useTranslation } from 'react-i18next';

export default function PrintRatingToast() {
  const { t } = useTranslation('bv');
  const store = usePrintStore();
  const rating = store && store.rating;
  const { submitPosterFeedback } = usePrintables();
  const [fav, setFav] = useState(false);
  useEffect(() => {
    if (!rating) return undefined;
    setFav(false);
    const t = setTimeout(() => store.clearRating(), 15000);
    return () => clearTimeout(t);
  }, [rating && rating.at]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!rating) return null;
  const toggleFav = () => {
    const next = !fav;
    setFav(next);
    submitPosterFeedback(rating.posterId, { favorite: next, source: 'post_print_toast' }).catch(() => {});
  };
  return (
    <div className="bv-rating-toast" role="status" data-testid="rating-toast">
      <div className="bv-rating-toast__head">
        <b>{t('print.rating.question')}</b>
        <button type="button" className="bv-rating-toast__x" aria-label={t('common.dismiss')} onClick={store.clearRating}><Icon name="x" size={16} /></button>
      </div>
      <div className="bv-rating-toast__row">
        <PosterRatingBar posterId={rating.posterId} source="post_print_toast" onDone={store.clearRating} />
        <button type="button" className={`bv-rating-toast__fav${fav ? ' is-on' : ''}`} aria-pressed={fav} aria-label={fav ? t('common.unfavourite') : t('common.favourite')} onClick={toggleFav} data-testid="rating-fav">
          <Icon name="heart" size={20} />
        </button>
      </div>
    </div>
  );
}
